(function () {
  const selector = 'video[data-tnc-managed-video]';

  function disableVideo(video) {
    video.pause();
    video.autoplay = false;
    video.removeAttribute('autoplay');
    video.preload = 'none';
    video.removeAttribute('src');
    video.querySelectorAll('source[src]').forEach((source) => source.removeAttribute('src'));
    video.load();
  }

  function enableVideo(video) {
    let addedSource = false;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      if (!source.src) {
        source.src = source.dataset.src;
        addedSource = true;
      }
    });

    if (addedSource) video.load();
    if (!video.hasAttribute('data-tnc-autoplay-video')) return;

    video.autoplay = true;
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.play().catch(() => {});
  }

  function updateVideos(root = document) {
    const videos = root.matches?.(selector) ? [root] : Array.from(root.querySelectorAll?.(selector) || []);
    videos.forEach(window.tncIsSlowDevice?.() ? disableVideo : enableVideo);
  }

  document.addEventListener('DOMContentLoaded', () => updateVideos());
  document.addEventListener('shopify:section:load', (event) => updateVideos(event.target));
  window.addEventListener('tnc:performance-profile-change', () => updateVideos());
})();
